import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'

import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import Select from '../../../packages/kiti/components/form/Select'
import { integrationsClient } from '../../../utils/apollo/api'
import { groupCategories } from './_helpers/helpers'

const QUERY = gql`
  query omieCategories($integrationId: Int, $page: Int) {
    omieCategories(integrationId: $integrationId, page: $page, limit: 999) {
      categoriaSuperior
      codigo
      descricao
      naoExibir
    }
  }
`

export const useCategorySelectLoader = filter => {
  const query = usePromiseQuery(QUERY, { client: integrationsClient })

  return (search, page = 1) => {
    return query({ search, page, ...filter })
      ?.then(pathOr([], ['data', 'omieCategories']))
      .then(data => {
        const filteredData = data?.filter(item => item?.naoExibir === 'N')
        const groupedData = groupCategories(filteredData)
        const result = groupedData.map((item, index) => {
          return {
            id: index,
            name: item.descricao,
            cCodCateg: item.codigo,
            group: item.group
          }
        })

        return result
      })
  }
}

const CategorySelect = ({ onChange, value, filter, ...props }) => {
  const getOptions = useCategorySelectLoader(filter)

  return <Select value={value} onChange={onChange} options={getOptions} {...props} />
}

export default CategorySelect
